export default __webpack_public_path__ + "static/media/Champagne rain3.cf1179aa.jpg";